import React, { useState, FunctionComponent, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import CheckboxTree from 'react-checkbox-tree';
import RegularButton from '../../../../components/RegularButton';
import { mapTree } from './utils';
import { IBindingCallback1 } from '../../../../common/models/callback';
import CustomPopover from '../../../../components/CustomPopover';
import { IAttribute } from '../../../../common/models/attribute/IAttribute';
import Icon from '../../../../components/Icon';
import styles from './styles.module.scss';

interface IProps {
  attributes: IAttribute[];
  onChange: IBindingCallback1<string[]>;
}

const AttributesFilter: FunctionComponent<IProps> = ({
  attributes,
  onChange
}) => {
  const tree = mapTree(attributes);

  const [checkedNodes, setCheckedNodes] = useState([] as string[]);
  const [expandedNodes, setExpandedNodes] = useState([] as string[]);

  useEffect(() => {
    onChange(checkedNodes);
  }, [checkedNodes]);

  const Trigger = () => (
    <div className={checkedNodes.length ? styles.attributesSelectedTrigger : styles.attributesTrigger}>
      <RegularButton
        textIntlId="ratingScale.filter"
        defaultMessage="Filter by competency"
        icon={<Icon icon="filter" />}
        variant={checkedNodes.length ? 'secondary' : 'tertiary'}
      />
    </div>
  );

  const AttributesDrodown = () => (
    <Card bsPrefix={`${styles.card} popup-body`}>
      <div className="tree-wrapper">
        <CheckboxTree
          nodes={tree}
          checked={checkedNodes}
          expanded={expandedNodes}
          onCheck={setCheckedNodes}
          onExpand={setExpandedNodes}
          icons={{
            check: <Icon icon="checkboxChecked" className="checkbox" />,
            uncheck: <Icon icon="checkboxUnchecked" className="checkbox uncheck" />,
            halfCheck: <Icon icon="checkboxIndeterminate" className="checkbox indeterminate" />,
            expandClose: <Icon icon="chevronUp" />,
            expandOpen: <Icon icon="chevronDown" />,
            parentClose: '',
            leaf: '',
            parentOpen: ''
          }}
        />
      </div>
    </Card>
  );

  return (
    <CustomPopover
      placement="bottom"
      trigger={<Trigger />}
      showArrow
      rootClose
    >
      <AttributesDrodown />
    </CustomPopover>
  );
};

export default AttributesFilter;
